<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
  <path d="M11.6415 8L6.07169 11.643L6.07169 4.357L11.6415 8ZM12.6818 8.58323C13.106 8.30577 13.106 7.69423 12.6818 7.41677L6.11078 3.1189C5.63598 2.80836 5 3.14228 5 3.70213L5 12.2979C5 12.8577 5.63597 13.1916 6.11077 12.8811L12.6818 8.58323Z"/>
</svg>
